import EnviarSimulacionModal from "./enviarSimulacionModal";
import Mensajes from "./mensajes";

export default class CotizarResumen extends React.Component {
  constructor() {
    super();

    this.state = {
      summaryDetailsExpanded: false,
      scrollY: 0,
      panelTopBeneficies: 0,
      initialStickyPanel: 83,
      initialStickyPanelOldDesktop: 113,
      initialTopPanel: 404,
      overlayTriggerPlacement: 'right',
      showError: false
    }

    this.showModal = this.showModal.bind(this);
    this.startShopping = this.startShopping.bind(this);
    this.changePanelStatus = this.changePanelStatus.bind(this);
    this.numberWithDots = this.numberWithDots.bind(this);
    this.getSummary = this.getSummary.bind(this);
    this.getElementOffset = this.getElementOffset.bind(this);
    this.showCotizador = this.showCotizador.bind(this);
  }

  numberWithDots(value) {
    return (value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  UrlCatcher() {
    var ultimaPosicion = window.location.pathname.split("/");
    var nivelAnterior = ultimaPosicion.slice(ultimaPosicion.length - 1);
    var text = "";
    nivelAnterior.forEach((item) => {
        text = text + "/" + item;
    });
    return decodeURI(text).slice(1);
  }

  showModal() {
    let userInfoCheck = compTools.obtenerInformacionUsuario();

    dataLayer.push({
      event: "cotizacion_plan",
      user_id: userInfoCheck.Nautcli,
      log_status: "true",
      login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
      affiliation: "Salud",
      bread_crumbs: this.UrlCatcher(),
      step: "Paso 2",
      option: this.props.planvital ? "Cotiza Plan Vital" : "Cotiza Plan Complementario Especial",
      action: "Enviar Información"
    })

    this.props.handleSubmit(() => {
      this.refs.modal.handleShow();
    });
  }

  startShopping(event) {
    event.preventDefault();
    let userInfoCheck = compTools.obtenerInformacionUsuario();

    dataLayer.push({
      event: "cotizacion_plan",
      user_id: userInfoCheck.Nautcli,
      log_status: "true",
      login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
      affiliation: "Salud",
      bread_crumbs: this.UrlCatcher(),
      step: "Paso 2",
      option: this.props.planvital ? "Cotiza Plan Vital" : "Cotiza Plan Complementario Especial",
      action: "Inicia tu Compra"
    })
    /* 
    Register click for security matters. 
    This service doesnt reply anything and won't change any other proccess
    */
    const registerClickService = new ServicioProxy('RegistraUltimoClic?ultimoclic=iniciacompra', 'ServicioConsorcio.svc');

    registerClickService.getElements('POST', {})
      .then(response => {
        window.location.href = _spPageContextInfo.webAbsoluteUrl + this.props.configurations['UrlPasoCeroClliente'];
      })
      .catch(error => {
        this.setState({ showError: true });
        setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
      })

  }

  changePanelStatus(expanded) {
    this.setState({ summaryDetailsExpanded: expanded });
  }

  getElementOffset(el) {
    const rect = el.getBoundingClientRect();

    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset,
      bottom: rect.bottom + window.pageYOffset,
    };
  }

  resetPanelFloat() {
    // const simulationFormBox = document.getElementById('box-cotizar');
    // const topSimulationForm = this.getElementOffset(simulationFormBox).top;
    // const summaryPanel = document.getElementById('cotizar-summary');
    // const footerPanelTop = this.getElementOffset(document.getElementById('beneficios')).top; 
    // this.setState({panelTopBeneficies: footerPanelTop})

    // return {
    //   simulationFormBox: simulationFormBox,
    //   topSimulationForm: topSimulationForm,
    //   summaryPanel: summaryPanel,
    //   footerPanelTop: footerPanelTop
    // }
  }

  setPanel = (top, position) => {
    // const summaryPanel = this.resetPanelFloat().summaryPanel;
    // summaryPanel.style["top"] =  top + 'px';
    // summaryPanel.style["position"] = position;
  }

  handleScroll = () => {
    // const simulationFormBox = this.resetPanelFloat().simulationFormBox.offsetHeight;
    // const summaryPanel = this.resetPanelFloat().summaryPanel;
    // const panelHeight = document.getElementById('cotizar-summary').offsetHeight;
    // const scrolltop =  window.scrollY + panelHeight;
    // const footerPanelTop = this.resetPanelFloat().footerPanelTop;
    // const topSimulationForm = this.resetPanelFloat().topSimulationForm;

    // this.setState({ scrollY: window.scrollY});

    // if (screen.width >= 992 && this.ieVersion() === 0) {
    //   if( this.state.scrollY > 306) {
    //     this.setPanel(0, 'absolute');
    //     if(scrolltop + this.state.initialStickyPanel < this.state.panelTopBeneficies) {
    //       this.setPanel( this.state.initialStickyPanel, 'fixed');
    //     } else {
    //       this.setPanel( this.state.panelTopBeneficies - panelHeight - this.state.initialTopPanel, 'relative');
    //     }  
    //   } else {
    //     summaryPanel.style["position"] = 'relative';
    //     summaryPanel.style["top"] =  0;
    //   }
    // } else if (screen.width === 1024 && screen.height === 768 && this.ieVersion() === 0) {
    //   if( this.state.scrollY > 306) {
    //     this.setPanel(0, 'absolute');
    //     if(scrolltop + this.state.initialStickyPanel < this.state.panelTopBeneficies - 30) {
    //       this.setPanel( this.state.initialStickyPanelOldDesktop, 'fixed');
    //     } else {
    //       this.setPanel( this.state.panelTopBeneficies - panelHeight - this.state.initialTopPanel - 18, 'relative');
    //     }  
    //   } else {
    //     summaryPanel.style["position"] = 'relative';
    //     summaryPanel.style["top"] =  0;
    //   }
    // } else{
    //   this.setState({ overlayTriggerPlacement: 'top' });
    //   summaryPanel.style["position"] = 'relative';
    //   summaryPanel.style["top"] =  0;
    // }
  }
  renderErrorModal() {
    return (
      <Mensajes ref="generalErrorModal" showModal={true} msg={this.state.errorMsg} />
    );
  }
  getSummary() {
    return (
      <div>
        {this.state.showError && this.renderErrorModal()}
        {!this.props.planvital ?
          <div className={'detail discounts' + (this.props.summary.epsDiscount == 0 && this.props.summary.cajaDiscount == 0 ? ' hidden' : '')}>
            <div className={'row mb-10' + (this.props.summary.epsDiscount == 0 ? ' hidden' : '')}>
              <div className="col-xs-6 text-right">
                Descuento por EPS
            </div>
              <div className="col-xs-6 detail-price">
                $ {this.numberWithDots(this.props.summary.epsDiscount)}
              </div>
            </div>
            <div className={'row' + (this.props.summary.cajaDiscount == 0 ? ' hidden' : '')}>
              <div className="col-xs-6 text-right">
                Descuento por Caja de compensación
              </div>
              <div className="col-xs-6 detail-price">
                $ {this.numberWithDots(this.props.summary.cajaDiscount)}
              </div>
            </div>
          </div>
          : null}
        {!this.props.planvital ?
          <div className="detail data">
            <div className="row mb-10">
              <div className="col-xs-6 text-right detail-label">
                {this.props.summary.lessthan60quantity} Afiliados <br /><span>Menores de 60</span>
              </div>
              <div className="col-xs-6 detail-price">
                $ {this.numberWithDots(this.props.summary.lessthan60total)}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6 text-right detail-label">
                {this.props.summary.morethan60quantity} Afiliados <br /><span>Mayores de 60</span>
              </div>
              <div className="col-xs-6 detail-price">
                $ {this.numberWithDots(this.props.summary.morethan60total)}
              </div>
            </div>
          </div>
          : null
        }
      </div>
    );
  }

  getStartPurchaseButtonMessage(message) {
    return <Popover id="popover-basic" placement={this.state.overlayTriggerPlacement} > {message} </Popover>
  }

  renderPurchaseComponent() {
    let component;

    if (!this.props.startShoppingProperties['PuedeIniciarCalendarioValue']) {
      component = <OverlayTrigger placement={this.state.overlayTriggerPlacement} overlay={this.getStartPurchaseButtonMessage(this.props.configurations['MensajeValidacionCalendarioSimulador'])}>
        <button id='start-purchase-button-disabled' type="button" disabled={this.props.options.component === 1 || this.props.planvital ? true : false} className={this.props.planvital ? "disabled btn btn-block btn-default btn-default-planvital" : "btn btn-block btn-default"}><i className="fa fa-shopping-cart"></i> Inicia tu Compra</button>
      </OverlayTrigger>;
    } else if (!this.props.startShoppingProperties['AutenticadoValue']) {
      component = <OverlayTrigger placement={this.state.overlayTriggerPlacement} overlay={this.getStartPurchaseButtonMessage(this.props.configurations['MensajeValidacionAutenticadoSimulador'])}>
        <button id='start-purchase-button-disabled' type="button" disabled={this.props.options.component === 1 || this.props.planvital ? true : false} className={this.props.planvital ? "disabled btn btn-block btn-default btn-default-planvital" : "btn btn-block btn-default"}><i className="fa fa-shopping-cart"></i> Inicia tu Compra</button>
      </OverlayTrigger>;
    } else if (this.props.startShoppingProperties['AutenticadoValue'] && !this.props.startShoppingProperties['PuedeIniciarAutogestionValue']) {
      component = <div>
        <button id='start-purchase-button-disabled' type="button" disabled={this.props.options.component === 1 || this.props.planvital ? true : false} className={this.props.planvital ? "disabled btn btn-block btn-default btn-default-planvital" : "btn btn-block btn-default"}><i className="fa fa-shopping-cart"></i> Inicia tu Compra</button>
        <p>{this.props.configurations['MensajeValidacionAutogestionSimulador']}</p>
      </div>;
    } else {
      component = <button onClick={this.startShopping} type="button" disabled={this.props.options.component === 1 || this.props.planvital ? true : false} className={this.props.planvital ? "disabled btn btn-block btn-default btn-default-planvital" : "btn btn-block btn-default"}><i className="fa fa-shopping-cart"></i> Inicia tu Compra</button>
    }

    return component;
  }

  showCotizador(event) {
    this.props.showCotizador(event);
  }

  render() {
    return (
      <div className="cotizar-summary float-panel" id="cotizar-summary" data-addsize="90" >
        <div className={'loadingWraper loadingWraper--' + (this.props.loadingSummary ? 'visible' : 'hidden')}><div className="compensarLoading"><span>cargando...</span></div></div>
        <div className="cotizar-summary-header">
          <p className="unit-price-label">Precio Mensual Desde</p>
          <h3 className="unit-price">
            ${this.numberWithDots(this.props.summary.monthlyFare)}
          </h3>
        </div>
        <div className="cotizar-summary-body hidden-xs">
          {this.getSummary()}
          <div className="detail total">
            <div className="row">
              <div className="col-xs-5 text-right detail-label">
                {this.props.planvital ? "TOTAL MES " : "TOTAL AÑO "}<br /><span>{this.props.summary.totalQuantity} Afiliados</span>
              </div>
              <div className="col-xs-7 detail-price">
                $ {this.numberWithDots(this.props.summary.total)}
              </div>
            </div>
          </div>
        </div>
        <div className="cotizar-summary-body visible-xs">
          <PanelGroup className="cotizar-summary-body-accordion">
            <Panel eventKey="1" onToggle={(expanded) => this.changePanelStatus(expanded)}>
              <Panel.Heading>
                <Panel.Title toggle>
                  <table>
                    <tbody>
                      <tr>
                        <td><i className={'fa ' + (this.state.summaryDetailsExpanded ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down')}></i></td>
                        <td>Plan complementario<br />Valor total anual</td>
                        <td>$ {this.numberWithDots(this.props.summary.total)}</td>
                      </tr>
                    </tbody>
                  </table>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {this.getSummary()}
              </Panel.Body>
            </Panel>
          </PanelGroup>
        </div>
        <div className="cotizar-important visible-xs">
          <strong>IMPORTANTE:</strong> {this.props.configurations['Importante']}
        </div>
        <div className="cotizar-summary-actions">
          {this.props.configurations['IniciarCompraLinkCSVisibleBool'] && (
            <div>
              {this.renderPurchaseComponent()}
              <div className="cotizar-summary-actions-separator"></div>
            </div>
          )}
          <button type="button" className={this.props.planvital ? "btn btn-block btn-primary-planvital " : "btn btn-block btn-primary"} onClick={this.showModal} disabled={!this.props.disabled}><i className="fa fa-envelope-open-o"></i> Enviar Información</button>
        </div>
        <EnviarSimulacionModal
          ref="modal"
          configurations={this.props.configurations}
          form={this.props.form}
          subscribed={this.props.subscribed}
          summary={this.props.summary}
          showCotizador={this.showCotizador}
          planvital={this.props.planvital}
          precio={this.props.precio}
          planvital={this.props.planvital}
        />
      </div>
    );
  }
}


/******************** BUILD ********************/
let Panel = ReactBootstrap.Panel;
let PanelGroup = ReactBootstrap.PanelGroup;
let Modal = ReactBootstrap.Modal;
let Popover = ReactBootstrap.Popover;
let OverlayTrigger = ReactBootstrap.OverlayTrigger;
/******************** BUILD ********************/

